import { parseJSON } from '@/components/helpers/utils'

// Custom hook for card options
export const useRecommendationCardOptions = (productCardOptions) => {
  const parsedProductCardOptions = parseJSON(productCardOptions)

  const cardOptions = productCardOptions && Object.keys(parsedProductCardOptions).length > 0
    ? { productCardOptions: parsedProductCardOptions }
    : {}

  const backgroundColour = parsedProductCardOptions.transparentCards
    ? 'bg-[--section-background-color,theme(colors.brand.white)]'
    : 'bg-brand-white [--section-background-color:theme(colors.brand.white)]'

  return { cardOptions, backgroundColour, parsedProductCardOptions }
}
